import api from './api';

const billingService = {
  // Get the current user's subscription
  getSubscription: async () => {
    const response = await api.get('/api/v1/billing/subscription');
    return response.data.data;
  },

  // Get available subscription plans
  getPlans: async () => {
    const response = await api.get('/api/v1/billing/plans');
    return response.data.data;
  },

  // Change subscription plan (upgrade/downgrade)
  changePlan: async (tier) => {
    const response = await api.put('/api/v1/billing/change-plan', null, {
      params: { tier },
    });
    return response.data.data;
  },

  // Create a Stripe Checkout session for initial subscription
  createCheckoutSession: async ({ tier, successUrl, cancelUrl, billingInterval }) => {
    const response = await api.post('/api/v1/billing/checkout', {
      tier,
      successUrl,
      cancelUrl,
      billingInterval: billingInterval || 'monthly',
    });
    return response.data.data;
  },

  // Create a Stripe billing portal session
  createPortalSession: async (returnUrl) => {
    const response = await api.post('/api/v1/billing/portal', null, {
      params: { returnUrl },
    });
    return response.data.data;
  },

  // Cancel subscription
  cancelSubscription: async (atPeriodEnd = true) => {
    const response = await api.post('/api/v1/billing/cancel', null, {
      params: { atPeriodEnd },
    });
    return response.data.data;
  },

  // Reactivate a canceled subscription
  reactivateSubscription: async () => {
    const response = await api.post('/api/v1/billing/reactivate');
    return response.data.data;
  },

  // List recent invoices
  listInvoices: async () => {
    const response = await api.get('/api/v1/billing/invoices');
    return response.data.data;
  },

  // List payment methods on file
  listPaymentMethods: async () => {
    const response = await api.get('/api/v1/billing/payment-methods');
    return response.data.data;
  },

  // Create a Stripe SetupIntent for adding a new payment method
  createSetupIntent: async () => {
    const response = await api.post('/api/v1/billing/payment-methods/setup');
    return response.data.data;
  },

  // Remove a payment method
  deletePaymentMethod: async (paymentMethodId) => {
    const response = await api.delete(
      `/api/v1/billing/payment-methods/${paymentMethodId}`
    );
    return response.data;
  },

  // Get AI usage stats for the current month
  getUsageStats: async () => {
    const response = await api.get('/api/v1/billing/usage');
    return response.data.data;
  },
};

export default billingService;
